<template>
	<div class="radio-button-group">
		<Radiobutton
			:name="`${uid}_rb`"
			:labelText="item.labelText"
			:disabled="item.disabled"
			v-for="(item, index) in items"
			:key="index"
			:value="item.value"
			:isActive="item.value === value"
			@input="selected"
		/>
	</div>
</template>

<script>
import Radiobutton from '@/components/forms/selection-control/radiobutton/radiobutton';
export default {
	components: { Radiobutton },
	name: 'RadiobuttonGroup',
	model: {
		prop: 'value',
		event: 'input'
	},
	props: {
		items: {
			default: () => {}
		},
		value: {
			// type: Number, String, Boolean,
			default: null
		}
	},

	methods: {
		selected(val) {
			return this.$emit('input', val);
		}
	}
	// created() {
	// 	this.listchecked = this.items.slice();
	// }
};
</script>

<style lang="scss">
.radio-button-group {
	display: grid;
	gap: $gutter-lg $gutter-xl;
	grid-template-columns: repeat(2, 1fr);
	grid-auto-flow: column;

	@include mq($from: sm-l) {
		grid-template-columns: inherit;
	}
}

.fieldset--vertical {
	.radio-button-group {
		grid-auto-flow: initial;
		grid-template-columns: 1fr;
	}
}
</style>
